import { createTestId } from '../../common/selectors';

export const infiniteScrollNumOfRows = createTestId('datalab-ng-infinite-scroll-num-of-rows');
